import React, { Component } from 'react';
import "./tuitionlist.css"
class Tuition extends Component {
  render() {
    

    return (
        
           
                             
                              
                                <tr>
                                    <td>{this.props.name}</td>
                                    <td>₦{this.props. amount}</td>
                                    <td>First term</td>
                                </tr>
                               
                                
                               
                                 
              

    )

}





}

export default Tuition;


// WEBPACK FOOTER //
// ./src/component/dashboard/tuitionlist.js